// TODO: https://product-fabric.atlassian.net/browse/DSP-3792
import { colors } from '@atlaskit/theme';

export const QUICK_DATE_FILTER_PAST_WEEK = 'past_week' as const;
export const QUICK_DATE_FILTER_PAST_2_WEEKS = 'past_2_weeks' as const;
export const QUICK_DATE_FILTER_PAST_MONTH = 'past_month' as const;
export const QUICK_DATE_FILTER_PAST_3_MONTHS = 'past_3_months' as const;
export const QUICK_DATE_FILTER_PAST_6_MONTHS = 'past_6_months' as const;
export const QUICK_DATE_FILTER_ALL_TIME = 'all_time' as const;
export const QUICK_DATE_FILTER_CUSTOM = 'custom' as const;

export const APP_ID = 'software.reports.cfd';
export const LOCATION = 'cumulativeFlowDiagram';

const N70 = [colors.N70, colors.N60];
const N200 = [colors.N200, colors.N100];
const P300 = [colors.P300, colors.P200];
const P200 = [colors.P200, colors.P100];
const T200 = [colors.T200, colors.T100];
const B100 = [colors.B100, colors.B75];
const Y100 = [colors.Y100, colors.Y75];
const Y200 = [colors.Y200, colors.Y100];
const G200 = [colors.G200, colors.G100];
const G300 = [colors.G300, colors.G200];

export const BASE_COLORS_10 = [N70, N200, P300, P200, T200, B100, Y100, Y200, G200, G300] as const;
export const BASE_COLORS_9 = [N70, N200, P300, P200, T200, B100, Y200, G200, G300] as const;
export const BASE_COLORS_8 = [N70, P300, P200, T200, B100, Y200, G200, G300] as const;
export const BASE_COLORS_7 = [P300, P200, T200, B100, Y200, G200, G300] as const;
export const BASE_COLORS_6 = [P200, T200, B100, Y200, G200, G300] as const;
export const BASE_COLORS_5 = [P200, T200, B100, Y200, G300] as const;
export const BASE_COLORS_4 = [P200, T200, B100, G300] as const;
export const BASE_COLORS_3 = [P200, T200, G300] as const;
export const BASE_COLORS_2 = [P200, G300] as const;
export const BASE_COLORS_1 = [P200] as const;

export const COLORS = {
	'0': [],
	'1': BASE_COLORS_1,
	'2': BASE_COLORS_2,
	'3': BASE_COLORS_3,
	'4': BASE_COLORS_4,
	'5': BASE_COLORS_5,
	'6': BASE_COLORS_6,
	'7': BASE_COLORS_7,
	'8': BASE_COLORS_8,
	'9': BASE_COLORS_9,
	'10': BASE_COLORS_10,
} as const;
